import React from "react";
import { useState } from "owa-react";
import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import { DrawerPane } from "owa-drawer";
import { ChatCopilotPane as LazyChatCopilotBody, ChatCopilotPaneHeader as LazyChatCopilotPaneHeader, } from "owa-copilot-chat";
import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";
import { observer } from "owa-mobx-react";
import { copilotChatHeader, copilotChatBody } from "../AppPaneGroup.scss";
import isFlexPaneShownHelper from "owa-app-pane-group-utils/lib/helpers/isFlexPaneShownHelper";

const CHAT_COPILOT_DEFAULT_WIDTH = 380;
const CHAT_COPILOT_EXPANDED_WIDTH = 594;

const defaultExport: React.FunctionComponent = observer(function ChatCopilotPane() {
    const paneId = getDrawerPaneId("chatCopilot");
    const [isExpanded, setIsExpanded] = useState(false);
    
    const width = isExpanded ? CHAT_COPILOT_EXPANDED_WIDTH : CHAT_COPILOT_DEFAULT_WIDTH;
    
    const handleToggleExpand = React.useCallback(() => {
        setIsExpanded(prev => !prev);
    }, []);
    
    const headerElement = React.useMemo(() => (<LazyChatCopilotPaneHeader isExpanded={isExpanded} onToggleExpand={handleToggleExpand}/>), [isExpanded, handleToggleExpand]);
    
    return (<DrawerPane paneId={paneId} headerText={headerElement} headerClassName={copilotChatHeader} bodyClassName={copilotChatBody} preload={isGlobalFeatureEnabled("fwk-copilot-iframe-preload")} role={"complementary"} width={width}>
            <LazyChatCopilotBody isVisible={isFlexPaneShownHelper("ChatCopilot", "chatCopilot")}/>
        </DrawerPane>);
}, "ChatCopilotPane");

export default defaultExport;
